import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {artifactShopLink} from 'app/components/my_profile/artifacts/utils';
import PrizeCard from 'app/components/reusable/PrizeCard';
import LootInterface from 'app/interfaces/LootInterface';
import {isLootBox} from 'app/utils/isLootBox';
import {getLinkPath} from 'app/utils/link_helper';
import {lootRarity} from 'app/utils/lootboxRarity';

interface Props {
    items: LootInterface[]
}

interface ItemProps {
    item: LootInterface
}

const setItemHref = (item: LootInterface): string | null => {
    const {recipe} = item;

    if (!recipe) {
        return null;
    }

    if (isLootBox(recipe.item_type)) {
        return recipe.slug ? getLinkPath(`/shop/lootboxes/${recipe.slug}`) : null;
    }

    return artifactShopLink(recipe);
};

const SetContentCard = ({item}: ItemProps): React.ReactElement => {
    const href = setItemHref(item);
    const card = <PrizeCard loot={item} hideMeta clickable={Boolean(href)} />;

    if (!href) {
        return card;
    }

    return <Link to={href}>{card}</Link>;
};

const SetContents = ({items}: Props): React.ReactElement | null => {
    if (items.length === 0) {
        return null;
    }

    return <>
        <h3 className="shop-item-detail__section-title">{I18n.t('shop.set_contents_title')}</h3>
        <div className="prize-card-grid prize-card-grid--set">
            {items.map((item: LootInterface, index: number) => <SetContentCard
                key={`${lootRarity(item)}-${index}`}
                item={item}
            />)}
        </div>
    </>;
};

export default SetContents;
